import { Box } from "@mui/material";
import { styled } from "@mui/material";
import Link from "next/link";

export const BoardSlider = styled(Box)<{}>(({ theme }) => ({
  overflow: "hidden",
  display: "flex",
  overflowX: "auto",
  scrollBehavior: "smooth",
  "::-webkit-scrollbar": {
    display: "none",
  },

  WebkitOverflowScrolling: "touch",

  webkitScrollbar: {
    display: "none",
  },

  [theme.breakpoints.up("lg")]: {
    maxWidth: "1440px",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    boxSizing: "border-box",
  },
}));

export const BoardSliderInner = styled(Box)<{}>(({ theme }) => ({
  scrollBehavior: "smooth",
  display: "flex",
  overflowX: "auto",

  [theme.breakpoints.up("lg")]: {
    display: "grid",
    gap: "2rem",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  },
}));

export const BoardItem = styled(Link)<{}>(({ theme }) => ({
  scrollSnapAlign: "start",
  flexShrink: 0,
  width: "272px",
  marginLeft: "1rem",
  flexFlow: "column wrap",
  padding: "1rem",
  cursor: "pointer",
  borderRadius: "1.5rem",
  border: "1px solid rgb(253, 252, 252)",

  "&:last-child": {
    marginRight: "1rem",
    [theme.breakpoints.up("md")]: {
      marginRight: "1.5rem",
    },
    [theme.breakpoints.up("lg")]: {
      marginRight: "0",
    },
  },

  "&:hover": {
    background: "rgba(82, 212, 204, 0.2)",
  },

  [theme.breakpoints.up("md")]: {
    marginLeft: "1.5rem",
    width: "310px",
  },
  [theme.breakpoints.up("lg")]: {
    marginLeft: "0",
  },

  img: {
    overflow: "hidden",
    borderRadius: "24px",
    marginBottom: "16px",
  },
}));

export const BoardItemBottom = styled("div")<{}>(({ theme }) => ({
  display: "flex",
  gap: "16px",
  justifyContent: "space-between",
  width: "100%",
}));

export const BoardItemIcon = styled("div")<{}>(({ theme }) => ({
  display: "flex",
  alignSelf: "center",
}));
